import { observer } from 'mobx-react-lite'
import React from 'react'

import TextField from '@mui/material/TextField'
import { useTheme } from '@mui/material/styles'

import { Dialog, useGlobalCopyStore, useSettingsStore } from '../../../../common'
import RuleListItem from '../components/RuleListItem'

const EditPayeeAction = observer(() => {
  const { common: commonCopy, settings: settingsCopy } = useGlobalCopyStore()
  const { selectedRule: rule, updateRulePayee } = useSettingsStore()

  const theme = useTheme()

  const [isOpen, setIsOpen] = React.useState(false)
  const initialPayeeName = rule?.description ? rule.description : rule?.match_description

  const [payeeName, setPayeeName] = React.useState(initialPayeeName ? initialPayeeName : '')

  const handleOpen = (): void => {
    setIsOpen(true)
  }

  const handleSave = async () => {
    if (payeeName !== initialPayeeName && rule) {
      rule.description = payeeName
      await updateRulePayee(rule)
      setIsOpen(false)
    }
  }

  return (
    <React.Fragment>
      <RuleListItem
        onClick={handleOpen}
        primaryText={initialPayeeName}
        secondaryText={settingsCopy.payee}
      />
      <Dialog
        copy={{ title: settingsCopy.edit_payee }}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onPrimaryAction={handleSave}
        onSecondaryAction={() => setIsOpen(false)}
        primaryText={commonCopy.save_button}
        secondaryText={commonCopy.cancel_button}
        sx={{
          '& .MuiDialogContent-root': { pt: 0, width: 400 },
          path: { fill: theme.palette.secondary.darker },
        }}
      >
        <TextField
          onChange={(e) => setPayeeName(e.target.value)}
          sx={{ width: 352 }}
          value={payeeName}
        />
      </Dialog>
    </React.Fragment>
  )
})

export default EditPayeeAction
